import React from 'react'

const LineLoader = () => {
    return (
        <div className='flex flex-col gap-2 w-full px-6 pt-6'>
            <div className='relative bg-gray-light w-[60%] h-5 rounded-lg overflow-hidden'>
                <div className='absolute bg-white/50 h-5 w-[10%] animate-slide blur-sm'></div>
            </div>
            <div className='relative bg-gray-light w-[60%] h-5 rounded-lg overflow-hidden'>
                <div className='absolute bg-white/50 h-5 w-[10%] animate-slide blur-sm'></div>
            </div>
            <div className='relative bg-gray-light w-[40%] h-5 rounded-lg overflow-hidden'>
                <div className='absolute bg-white/50 h-5 w-[10%] animate-slide blur-sm'></div>
            </div>
        </div>
    )
}

export default LineLoader